import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { useStateContext } from "state";

const useGetOrganization = () => {
  const clients = useClientContext();
  const state = useStateContext();
  const organizationId = state.user?.organizationId;

  const { data, isLoading, isSuccess, isError } = useQuery({
    queryKey: ["getOrganization", state.tokens?.user_id, organizationId],
    queryFn: async () => {
      if (!organizationId) {
        throw new Error("organization_id is required");
      }
      return await clients.management.getOrganizationDetails(organizationId);
    },
    staleTime: 2 * 60 * 100, // Data is fresh for 2 minutes
    enabled: !!organizationId,
  });

  return {
    data,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetOrganization;
